import {createApp} from 'vue'
import store from 'store'
import ForumEditProfile from './ForumEditProfile'

const el = '.kb-component--forum-edit-profile'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ForumEditProfileDOM)=>{
            const props = {
                content: ForumEditProfileDOM.dataset.content ? JSON.parse(ForumEditProfileDOM.dataset.content) : {},
                continueUrl : ForumEditProfileDOM.dataset.continueUrl,
                continueUrlWithData:  ForumEditProfileDOM.dataset.continueUrlWithData
            }
            store.commit('main/set_page_overlay_content_data', {
                userId: ForumEditProfileDOM.dataset.userId
            })
            const component = createApp(ForumEditProfile, props).use(Store)
            component.mount(ForumEditProfileDOM)
        })
    }
}